import { ReactNode } from 'react'

interface CalculationRowProps {
  left: ReactNode
  center?: ReactNode
  right: ReactNode
  inCard?: boolean
}

export const CalculationRow = ({
  left,
  center,
  right,
  inCard,
}: CalculationRowProps) => {
  const shouldUseCenterColumn = Boolean(center)

  return (
    <div className="flex flex-col sm:flex-row items-end justify-between w-full">
      {/* Left */}
      <div
        className={
          shouldUseCenterColumn ? 'sm:w-2/3 w-full' : 'sm:w-5/6 w-full'
        }
      >
        {left}
      </div>

      {/* Center (only shown on larger screens) */}
      {shouldUseCenterColumn && (
        <div className="hidden sm:flex sm:w-1/6 justify-end items-end">
          {center}
        </div>
      )}

      {/* Right */}
      <div
        className={`w-full sm:w-${shouldUseCenterColumn ? '1/6' : '1/3'} flex justify-end items-end ${
          inCard ? '' : 'pr-9'
        }`}
      >
        {/* On small screens, center appears above right */}
        {shouldUseCenterColumn && (
          <div className="sm:hidden mb-1 w-full flex justify-end">{center}</div>
        )}
        {right}
      </div>
    </div>
  )
}
